module.exports = __webpack_public_path__ + "img/Sedan_Side_Left.a71180be.svg";